var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import MobileDetect from "mobile-detect";
import { connect } from "@irati/store";
import shouldRedirectToGDPR from "@irati/onboarding/helpers/shouldRedirectToGDPR";
import TermsAndConditions from "@irati-web/onboarding/src/containers/TermsAndConditions";
import SetDetailsModal from "@irati-web/onboarding/src/components/UserOnboarding/SetDetailsModal";
import TenantSetupNotification from "@irati-web/tenantsetup/src/components/FullScreenNotification";
import Header from "@irati-web/platform/src/components/Header";
/* eslint-disable no-restricted-imports */
/** @description: Tech debt, this should be moved outside the ui folder */
import authentication from "@irati/auth";
/* eslint-enable no-restricted-imports */
import hasSetDetails from "@irati/onboarding/helpers/hasSetDetails";
import Footer from "./Footer";
import Oops from "./Oops";
import MobileDisabled from "./MobileDisabled";
import { Main } from "./styled";
var AppContainer = /** @class */ (function (_super) {
    __extends(AppContainer, _super);
    function AppContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            caught: null
        };
        _this.componentDidCatch = function (caught) {
            _this.setState({ caught: caught });
        };
        _this.shouldShowMobileDisabled = function () {
            var _a = _this.props, disableMobile = _a.disableMobile, mq = _a.mq;
            if (!disableMobile) {
                return false;
            }
            var detect = new MobileDetect(window.navigator.userAgent);
            return disableMobile && (mq.lessThan.medium || detect.mobile());
        };
        return _this;
    }
    AppContainer.prototype.render = function () {
        var _a = this.props, auth = _a.auth, children = _a.children, isFlush = _a.isFlush, hasFooter = _a.hasFooter, addContentMarginTop = _a.addContentMarginTop, mainBackground = _a.mainBackground;
        var caught = this.state.caught;
        var onboarding = auth.onboarding, user = auth.user;
        var isLoggedIn = authentication.isLoggedIn();
        if (onboarding && shouldRedirectToGDPR(onboarding) && isLoggedIn) {
            return React.createElement(TermsAndConditions, null);
        }
        var showSetDetailsPopup = isLoggedIn && !hasSetDetails(onboarding);
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null),
            React.createElement(Main, { flush: isFlush, marginTop: addContentMarginTop, mainBackground: mainBackground, className: "main" },
                !caught && (this.shouldShowMobileDisabled() ? React.createElement(MobileDisabled, null) : children),
                caught && React.createElement(Oops, { caught: caught })),
            hasFooter && React.createElement(Footer, null),
            isLoggedIn && React.createElement(TenantSetupNotification, null),
            showSetDetailsPopup && React.createElement(SetDetailsModal, { user: user })));
    };
    AppContainer.defaultProps = {
        disableMobile: false,
        hasFooter: true,
        isFlush: false
    };
    AppContainer.contextTypes = {
        appPath: PropTypes.string.isRequired,
        apps: PropTypes.object.isRequired
    };
    return AppContainer;
}(Component));
var mapStateToProps = function (state) {
    return {
        mq: state.mq,
        auth: state.auth
    };
};
export default connect(mapStateToProps)(AppContainer);
